var styles = ":export {\n  brandPrimaryColor1: var(--brand-primary-color-1);\n  brandPrimaryColorDarker10: var(--brand-primary-color-darker-10);\n  brandHighlightCardBg: var(--brand-highlight-card-background);\n  brandSectionBg: var(--brand-section-background);\n  brandIconGreyShade1: var(--brand-icon-grey-shade-1);\n  brandSecondaryIconGreen: var(--brand-secondary-icon-green);\n  brandSearchBarBackground: var(--brand-search-bar-background);\n  brandNewsletterFooterBackground: var(--brand-newsletter-footer-background);\n  brandHeaderBackground: var(--brand-header-background);\n  brandHeaderColor1: var(--brand-header-color-1);\n  brandHeaderColorText1: var(--brand-header-color-text-1);\n  brandHeaderColorText2: var(--brand-header-color-text-2);\n  brandHeaderColorTooltipText: var(--brand-header-color-tooltip-text);\n  brandFooterBackground: var(--brand-footer-background);\n  brandFooterTitle: var(--brand-footer-title);\n  brandFooterContent: var(--brand-footer-content);\n  brandFooterIcon: var(--brand-footer-icon);\n  brandDarkBlue: var(--brand-dark-blue);\n  brandLightBlue: var(--brand-light-blue);\n  brandDarkGreen: var(--brand-dark-green);\n  brandBrightGreen: var(--brand-bright-green);\n  brandLightGreen: var(--brand-light-green);\n  brandPink: var(--brand-pink);\n  brandYellowShade2: var(--brand-yellow-shade-2);\n  brandPurple: var(--brand-purple);\n  brandFontBold: var(--brand-font-bold);\n  brandFontMedium: var(--brand-font-medium);\n  brandFontRegular: var(--brand-font-regular);\n  collectionSuperdarkgrey: #1C1C1C;\n  collectionDarkgrey: #393939;\n  collectionMediumGrey: #595959;\n  collectionLightGrey: #EBEBEB;\n  collectionSuperLightGrey: #FAFAFA;\n  collectionBlack: #000000;\n  collectionWhite: #FFFFFF;\n  collectionPromoRed: #DF1D42;\n  collectionPromoRed2: #E30421;\n  collectionColourError: #D85353;\n  collectionColourHighlight: #F6B900;\n  collectionColourInformation: #0091FF;\n  collectionColourSuccess: #48B488;\n  collectionColourTurqouise1: #00C4B3;\n  collectionColourWarning: #FEEF6D;\n  collectionYellowOrange: #f49800;\n}";

const { collectionWhite, collectionBlack, collectionDarkgrey, collectionPromoRed2, collectionColourTurqouise1 } = styles;

/**
 Object of locales. Used in  brandingImporter()
 * @private
 */
const locales = {
  french: 'fr-FR',
  italian: 'it-IT',
  spanish: 'es-ES',
  swissFrench: 'fr-CH',
  swissGerman: 'de-CH',
  swissItalian: 'it-CH',
  swedish: 'sv-SE',
  danish: 'da-DK',
  dutch: 'nl-NL',
  belgianDutch: 'nl-BE',
  belgianFrench: 'fr-BE',
  irish: 'en-IE',
  german: 'de-DE',
};

/***
 * @description Object of brands. Used in  supportsLocale()
 * @private
 */
const brands = {
  smartbox: 'sbx',
  dakotaSpain: 'dakEs',
  dakotaFrance: 'dakFr',
  bongo: 'bon',
  emozione: 'emo',
  lavidaesbella: 'lav',
  cadeaubox: 'cbx',
};

/***
 * @description Object of brandingThemes. Used in  brandingImporter()
 * @private
 */
const brandingThemes = {
  sbx: {
    '--brand-theme': 'sbx',
    '--brand-primary-color-1': '#EB5F40',
    '--brand-primary-color-darker-10': '#e03c18', //darken color 10%
    '--brand-primary-color-lighten-10': '#FBEEEE', //lighten color
    '--brand-highlight-card-background': '#FFF8EA',
    '--brand-section-background': '#F9F6F6',
    '--brand-icon-grey-shade-1': '#777777',
    '--brand-secondary-icon-green': 'unset',
    '--brand-search-bar-background': collectionWhite,
    '--brand-newsletter-footer-background': '#4C509D',
    '--brand-header-background': collectionWhite,
    '--brand-header-title': collectionDarkgrey,
    '--brand-header-color-1': '#EB5F40',
    '--brand-header-color-text-1': collectionWhite,
    '--brand-header-color-text-2': '#343533',
    '--brand-header-color-tooltip-text': '#343533',
    '--brand-megamenu-background': '#f9f6f6',
    '--brand-megamenu-title': collectionDarkgrey,
    '--brand-footer-background': '#EEECE8',
    '--brand-footer-title': '#6e6963',
    '--brand-footer-content': '#343533',
    '--brand-footer-icon': '#f4f0ed',
    '--brand-dark-blue': '#4C509D',
    '--brand-light-blue': '#B1DDE8',
    '--brand-dark-green': '#006648',
    '--brand-bright-green': '#009847',
    '--brand-light-green': '#D1D700',
    '--brand-yellow-shade-1': '#FFD300',
    '--brand-pink': '#F7C4DC',
    '--brand-yellow-shade-2': '#FFE598',
    '--brand-purple': '#7E2182',
    '--brand-font-regular': 'smartbox',
    '--brand-font-bold': 'smartbox-bold',
    '--brand-font-medium': 'smartbox-medium',
  },
  bon: {
    '--brand-theme': 'bon',
    '--brand-primary-color-1': '#AFBC22',
    '--brand-primary-color-darker-10': '#9da91e',
    '--brand-primary-color-lighten-10': '#F4F9ED',
    '--brand-highlight-card-background': '#FBFDEA',
    '--brand-section-background': '#F9F6F6',
    '--brand-icon-grey-shade-1': '#777777',
    '--brand-secondary-icon-green': '#00C4B3',
    '--brand-search-bar-background': collectionWhite,
    '--brand-newsletter-footer-background': '#4C509D',
    '--brand-header-background': collectionWhite,
    '--brand-header-title': '#343533',
    '--brand-header-color-1': '#AFBC22',
    '--brand-header-color-text-1': collectionWhite,
    '--brand-header-color-text-2': '#343533',
    '--brand-header-color-tooltip-text': '#343533',
    '--brand-megamenu-background': '#f9f6f6',
    '--brand-megamenu-title': '#343533',
    '--brand-footer-background': '#EEECE8',
    '--brand-footer-title': '#6e6963',
    '--brand-footer-content': '#343533',
    '--brand-footer-icon': '#f4f0ed',
    '--brand-dark-blue': '#4C509D',
    '--brand-light-blue': 'unset',
    '--brand-dark-green': 'unset',
    '--brand-bright-green': 'unset',
    '--brand-light-green': 'unset',
    '--brand-yellow-shade-1': '#FFD300',
    '--brand-pink': 'unset',
    '--brand-yellow-shade-2': 'unset',
    '--brand-purple': '#7E2182',
    '--brand-font-regular': 'bon',
    '--brand-font-bold': 'bon-bold',
    '--brand-font-medium': 'bon-medium',
  },
  cbx: {
    '--brand-theme': 'cbx',
    '--brand-primary-color-1': collectionPromoRed2,
    '--brand-primary-color-darker-10': '#cc031d',
    '--brand-primary-color-lighten-10': '#FCE6E9',
    '--brand-highlight-card-background': '#FFF8EA',
    '--brand-section-background': '#F9F6F6',
    '--brand-icon-grey-shade-1': 'unset',
    '--brand-secondary-icon-green': '#00C4B3',
    '--brand-search-bar-background': '#EFEFEF',
    '--brand-newsletter-footer-background': '#252525',
    '--brand-header-background': collectionWhite,
    '--brand-header-title': '#393939',
    '--brand-header-color-1': collectionPromoRed2,
    '--brand-header-color-text-1': collectionWhite,
    '--brand-header-color-text-2': '#393939',
    '--brand-header-color-tooltip-text': '#6E6963',
    '--brand-megamenu-background': '#f9f6f6',
    '--brand-megamenu-title': '#393939',
    '--brand-footer-background': '#EEECE8',
    '--brand-footer-title': '#393939',
    '--brand-footer-content': '#393939',
    '--brand-footer-icon': '#f4f0ed',
    '--brand-dark-blue': 'unset',
    '--brand-light-blue': 'unset',
    '--brand-dark-green': 'unset',
    '--brand-bright-green': 'unset',
    '--brand-light-green': 'unset',
    '--brand-yellow-shade-1': 'unset',
    '--brand-pink': 'unset',
    '--brand-yellow-shade-2': 'unset',
    '--brand-purple': '#7E2182',
    '--brand-font-regular': 'din',
    '--brand-font-bold': 'din-bold',
    '--brand-font-medium': 'din-medium',
  },
  dakFr: {
    '--brand-theme': 'dakFr',
    '--brand-primary-color-1': collectionPromoRed2,
    '--brand-primary-color-darker-10': '#cc031d',
    '--brand-primary-color-lighten-10': '#FCE6E9',
    '--brand-highlight-card-background': '#FFF8EA',
    '--brand-section-background': '#F9F6F6',
    '--brand-icon-grey-shade-1': 'unset',
    '--brand-secondary-icon-green': collectionColourTurqouise1,
    '--brand-search-bar-background': '#EFEFEF',
    '--brand-newsletter-footer-background': '#252525',
    '--brand-header-background': collectionWhite,
    '--brand-header-title': '#393939',
    '--brand-header-color-1': collectionPromoRed2,
    '--brand-header-color-text-1': collectionWhite,
    '--brand-header-color-text-2': '#393939',
    '--brand-header-color-tooltip-text': '#6E6963',
    '--brand-megamenu-background': '#f9f6f6',
    '--brand-megamenu-title': '#393939',
    '--brand-footer-background': '#F3F3F3',
    '--brand-footer-title': '#393939',
    '--brand-footer-content': '#393939',
    '--brand-footer-icon': '#f4f0ed',
    '--brand-dark-blue': 'unset',
    '--brand-light-blue': 'unset',
    '--brand-dark-green': 'unset',
    '--brand-bright-green': 'unset',
    '--brand-light-green': 'unset',
    '--brand-yellow-shade-1': 'unset',
    '--brand-pink': 'unset',
    '--brand-yellow-shade-2': 'unset',
    '--brand-purple': '#7E2182',
    '--brand-font-regular': 'din',
    '--brand-font-bold': 'din-bold',
    '--brand-font-medium': 'din-medium',
  },
  dakEs: {
    '--brand-theme': 'dakEs',
    '--brand-primary-color-1': collectionPromoRed2,
    '--brand-primary-color-darker-10': '#cc031d',
    '--brand-primary-color-lighten-10': '#FCE6E9',
    '--brand-highlight-card-background': '#FFF8EA',
    '--brand-section-background': collectionBlack,
    '--brand-icon-grey-shade-1': 'unset',
    '--brand-secondary-icon-green': collectionColourTurqouise1,
    '--brand-search-bar-background': collectionWhite,
    '--brand-newsletter-footer-background': '#F2F2F2',
    '--brand-header-background': '#000000',
    '--brand-header-title': collectionWhite,
    '--brand-header-color-1': collectionPromoRed2,
    '--brand-header-color-text-1': collectionWhite,
    '--brand-header-color-text-2': collectionWhite,
    '--brand-header-color-tooltip-text': '#6E6963',
    '--brand-megamenu-background': '#000000',
    '--brand-megamenu-title': collectionWhite,
    '--brand-footer-background': '#252525',
    '--brand-footer-title': '#ffffff',
    '--brand-footer-content': '#ffffff',
    '--brand-footer-icon': '#252525',
    '--brand-dark-blue': 'unset',
    '--brand-light-blue': 'unset',
    '--brand-dark-green': 'unset',
    '--brand-bright-green': 'unset',
    '--brand-light-green': 'unset',
    '--brand-yellow-shade-1': 'unset',
    '--brand-pink': 'unset',
    '--brand-yellow-shade-2': 'unset',
    '--brand-purple': '#7E2182',
    '--brand-font-regular': 'din',
    '--brand-font-bold': 'din-bold',
    '--brand-font-medium': 'din-medium',
  },
  emo: {
    '--brand-theme': 'emo',
    '--brand-primary-color-1': collectionPromoRed2,
    '--brand-primary-color-darker-10': '#cc031d',
    '--brand-primary-color-lighten-10': '#FCE6E9',
    '--brand-highlight-card-background': '#FFF8EA',
    '--brand-section-background': collectionPromoRed2,
    '--brand-icon-grey-shade-1': 'unset',
    '--brand-secondary-icon-green': collectionColourTurqouise1,
    '--brand-search-bar-background': collectionWhite,
    '--brand-newsletter-footer-background': '#525252',
    '--brand-header-background': '#E30421',
    '--brand-header-title': collectionWhite,
    '--brand-header-color-1': collectionWhite,
    '--brand-header-color-text-1': collectionPromoRed2,
    '--brand-header-color-text-2': collectionWhite,
    '--brand-header-color-tooltip-text': '#6E6963',
    '--brand-megamenu-background': '#E30421',
    '--brand-megamenu-title': collectionWhite,
    '--brand-footer-background': '#EFEFEF',
    '--brand-footer-title': '#6e6963',
    '--brand-footer-content': '#535353',
    '--brand-footer-icon': '#f4f0ed',
    '--brand-dark-blue': 'unset',
    '--brand-light-blue': 'unset',
    '--brand-dark-green': 'unset',
    '--brand-bright-green': 'unset',
    '--brand-light-green': 'unset',
    '--brand-yellow-shade-1': 'unset',
    '--brand-pink': 'unset',
    '--brand-yellow-shade-2': 'unset',
    '--brand-purple': '#7E2182',
    '--brand-font-regular': 'din',
    '--brand-font-bold': 'din-bold',
    '--brand-font-medium': 'din-medium',
  },
  lav: {
    '--brand-theme': 'lav',
    '--brand-primary-color-1': collectionPromoRed2,
    '--brand-primary-color-darker-10': '#cc031d',
    '--brand-primary-color-lighten-10': '#FCE6E9',
    '--brand-highlight-card-background': '#FFF8EA',
    '--brand-section-background': '#F9F6F6',
    '--brand-icon-grey-shade-1': 'unset',
    '--brand-secondary-icon-green': collectionColourTurqouise1,
    '--brand-search-bar-background': '#EFEFEF',
    '--brand-newsletter-footer-background': '#393939',
    '--brand-header-background': collectionWhite,
    '--brand-header-title': '#393939',
    '--brand-header-color-1': collectionPromoRed2,
    '--brand-header-color-text-1': collectionWhite,
    '--brand-header-color-text-2': '#393939',
    '--brand-header-color-tooltip-text': '#6E6963',
    '--brand-megamenu-background': collectionPromoRed2,
    '--brand-megamenu-title': collectionWhite,
    '--brand-footer-background': '#F3F3F3',
    '--brand-footer-title': '#393939',
    '--brand-footer-content': '#393939',
    '--brand-footer-icon': '#f4f0ed',
    '--brand-dark-blue': 'unset',
    '--brand-light-blue': 'unset',
    '--brand-dark-green': 'unset',
    '--brand-bright-green': 'unset',
    '--brand-light-green': 'unset',
    '--brand-yellow-shade-1': 'unset',
    '--brand-pink': 'unset',
    '--brand-yellow-shade-2': 'unset',
    '--brand-purple': '#7E2182',
    '--brand-font-regular': 'din',
    '--brand-font-bold': 'din-bold',
    '--brand-font-medium': 'din-medium',
  },
};

const domainSearchBrandingMap = {
  [brands.dakotaSpain]: [/^https?:\/\/[^/]+\.dakotabox\.es/, /^https?:\/\/[^/]+\/ds\//],
  [brands.dakotaFrance]: [/^https?:\/\/[^/]+\.dakotabox\.fr/, /^https?:\/\/[^/]+\/df\//],
  [brands.emozione]: [/^https?:\/\/[^/]+\.emozione3\.it/, /^https?:\/\/[^/]+\/ez\//],
  [brands.lavidaesbella]: [/^https?:\/\/[^/]+\.lavidaesbella\.es/, /^https?:\/\/[^/]+\/lv\//],
  [brands.bongo]: [/^https?:\/\/[^/]+\.bongo\.nl/, /^https?:\/\/[^/]+\.bongo\.be/, /^https?:\/\/[^/]+\/(bb|bn)\//],
  [brands.cadeaubox]: [/^https?:\/\/[^/]+\.cadeaubox\.be/, /^https?:\/\/[^/]+\/cb\//],
  [brands.smartbox]: [/^https?:\/\/[^/]+\/(fr|es|it|de|dk|se|ch\/(it|fr))\//],
};

const localeMap = {
  [locales.swissFrench]: [/\/ch\/fr\//],
  [locales.swissItalian]: [/\/ch\/it\//],
  [locales.swissGerman]: [/\/ch\//, /\/ch\/de\//],
  [locales.belgianFrench]: [/\.be\/fr\//, /\/be\/fr\//, /\/bb\/fr\//, /\/cb\/fr/],
  [locales.belgianDutch]: [/\.be\//, /\.be\/nl/, /\/be\/nl\//, /\/bb\//, /\/bb\/nl\//, /\/cb\//, /\/cb\/nl\//],
  [locales.french]: [/\.fr\//, /\/fr\//],
  [locales.italian]: [/\.it\//, /\/it\//, /\/ez\//],
  [locales.spanish]: [/\.es\//, /\/es\//, /\/ds\//, /\/lv\//],
  [locales.swedish]: [/\.se\//, /\/se\//],
  [locales.danish]: [/\.dk\//, /\/dk\//],
  [locales.dutch]: [/\.nl\//, /\/nl\//, /\/bn\//],
  [locales.irish]: [/\.ie\//, /\/ie\//],
  [locales.german]: [/\.de\//, /\/de\//],
};

/**
 * @private
 * @description Objects used as part of currencyFormat
 */
const currencyStyles = {
  pre: 'pre',
  post: 'post',
  postS: 'postS',
};

const currencies = {
  EUR: '€',
  CHF: 'CHF',
  SEK: 'kr',
  DKK: 'kr.',
};

const delimiters = {
  comma: ',',
  dot: '.',
};

const thousandsSeparators = {
  space: ' ',
  dot: '.',
  comma: ',',
};

/***
 * @description Array of different currency formats. Used in  currencyInfo / brandingImporter()
 * @private
 */
const currencyFormat = [
  {
    brand: brands.smartbox,
    locale: locales.french,
    currency: currencies.EUR,
    currencyStyle: currencyStyles.postS,
    delimiter: delimiters.comma,
    thousands: thousandsSeparators.space,
  },
  {
    brand: brands.smartbox,
    locale: locales.italian,
    currency: currencies.EUR,
    currencyStyle: currencyStyles.postS,
    delimiter: delimiters.comma,
    thousands: thousandsSeparators.dot,
  },
  {
    brand: brands.smartbox,
    locale: locales.spanish,
    currency: currencies.EUR,
    currencyStyle: currencyStyles.post,
    delimiter: delimiters.comma,
    thousands: thousandsSeparators.dot,
  },
  {
    brand: brands.smartbox,
    locale: locales.swissFrench,
    currency: currencies.CHF,
    currencyStyle: currencyStyles.pre,
    delimiter: delimiters.dot,
    thousands: thousandsSeparators.comma,
  },
  {
    brand: brands.smartbox,
    locale: locales.swissGerman,
    currency: currencies.CHF,
    currencyStyle: currencyStyles.pre,
    delimiter: delimiters.dot,
    thousands: thousandsSeparators.comma,
  },
  {
    brand: brands.smartbox,
    locale: locales.swissItalian,
    currency: currencies.CHF,
    currencyStyle: currencyStyles.pre,
    delimiter: delimiters.dot,
    thousands: thousandsSeparators.comma,
  },
  {
    brand: brands.smartbox,
    locale: locales.german,
    currency: currencies.EUR,
    currencyStyle: currencyStyles.postS,
    delimiter: delimiters.comma,
    thousands: thousandsSeparators.space,
  },
  {
    brand: brands.smartbox,
    locale: locales.swedish,
    currency: currencies.SEK,
    currencyStyle: currencyStyles.postS,
    delimiter: delimiters.comma,
    thousands: thousandsSeparators.space,
  },
  {
    brand: brands.smartbox,
    locale: locales.danish,
    currency: currencies.DKK,
    currencyStyle: currencyStyles.postS,
    delimiter: delimiters.comma,
    thousands: thousandsSeparators.dot,
  },
  {
    brand: brands.lavidaesbella,
    locale: locales.spanish,
    currency: currencies.EUR,
    currencyStyle: currencyStyles.post,
    delimiter: delimiters.comma,
    thousands: thousandsSeparators.dot,
  },
  {
    brand: brands.dakotaSpain,
    locale: locales.spanish,
    currency: currencies.EUR,
    currencyStyle: currencyStyles.post,
    delimiter: delimiters.comma,
    thousands: thousandsSeparators.dot,
  },
  {
    brand: brands.dakotaFrance,
    locale: locales.french,
    currency: currencies.EUR,
    currencyStyle: currencyStyles.postS,
    delimiter: delimiters.comma,
    thousands: thousandsSeparators.space,
  },
  {
    brand: brands.bongo,
    locale: locales.dutch,
    currency: currencies.EUR,
    currencyStyle: currencyStyles.pre,
    delimiter: delimiters.comma,
    thousands: thousandsSeparators.dot,
  },
  {
    brand: brands.bongo,
    locale: locales.belgianDutch,
    currency: currencies.EUR,
    currencyStyle: currencyStyles.pre,
    delimiter: delimiters.comma,
    thousands: thousandsSeparators.dot,
  },
  {
    brand: brands.bongo,
    locale: locales.belgianFrench,
    currency: currencies.EUR,
    currencyStyle: currencyStyles.postS,
    delimiter: delimiters.comma,
    thousands: thousandsSeparators.dot,
  },
  {
    brand: brands.cadeaubox,
    locale: locales.belgianFrench,
    currency: currencies.EUR,
    currencyStyle: currencyStyles.postS,
    delimiter: delimiters.comma,
    thousands: thousandsSeparators.dot,
  },
  {
    brand: brands.cadeaubox,
    locale: locales.belgianDutch,
    currency: currencies.EUR,
    currencyStyle: currencyStyles.pre,
    delimiter: delimiters.comma,
    thousands: thousandsSeparators.dot,
  },
  {
    brand: brands.emozione,
    locale: locales.italian,
    currency: currencies.EUR,
    currencyStyle: currencyStyles.postS,
    delimiter: delimiters.comma,
    thousands: thousandsSeparators.dot,
  },
  {
    brand: brands.smartbox,
    locale: locales.irish,
    currency: currencies.EUR,
    currencyStyle: currencyStyles.postS,
    delimiter: delimiters.comma,
    thousands: thousandsSeparators.space,
  },
];

/***
 * @private
 * @param {string} brand The used currency (€, CHF, kr)
 * @param {string} locale The delimiter for decimals
 * @returns {object}
 * @description Finds currencyFormat from locale. Note: exported as 'currency' in the brandingImporter object
 */
function getLocaleCurrencyFormat(brand, locale) {
  const localeFormat = currencyFormat.find(item => {
    return item.brand === brand && item.locale === locale;
  });

  if (!localeFormat) {
    logInvalidCombinationError(brand, locale);
    return {};
  }

  return localeFormat;
}

/***
 * @param {number} value
 * @param {object} options
 * @param {string} options.currency The used currency (€, CHF, kr)
 * @param {string} options.delimiter The delimiter for decimals
 * @param {string} options.thousands The separator for thousands
 * @param {string} options.currencyStyle How the currency symbol is displayed
 * @returns {string}
 * @description Formats 'value' to a currency. Negative values are treated as positive. currencyInfo can be grabbed from the brandingImporter obejct
 */
function formatPrice(value, currencyInfo) {
  if (value == 0) return '0';
  if (!value) return '';

  // round the value to 2 decimals and use the absolute value
  const stringValue = Math.abs(value.toFixed(2)).toString();
  const splitValue = stringValue.split('.');
  const wholeValue = getWholeValue(splitValue[0], currencyInfo.thousands);
  const decimalValue = getDecimalValue(splitValue[1]);

  const formattedValue = wholeValue + currencyInfo.delimiter + decimalValue;

  switch (currencyInfo.currencyStyle) {
    case currencyStyles.pre:
      return currencyInfo.currency + ' ' + formattedValue;
    case currencyStyles.post:
      return formattedValue + currencyInfo.currency;
    default:
      return formattedValue + ' ' + currencyInfo.currency;
  }
}

/***
 * @private
 * @param {string} value not null
 * @param {string} thousands
 * @returns {string}
 */
function getWholeValue(value, thousands) {
  return value.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
}

/***
 * @private
 * @param {string} value not null
 * @returns {string}
 */
function getDecimalValue(value) {
  let returnedValue = value || '';
  while (returnedValue.length < 2) {
    returnedValue += '0';
  }

  return returnedValue;
}

/***
 * @private
 * @param {string} brand
 * @param {string} locale
 * @returns {string}
 */
function logInvalidCombinationError(brand, locale) {
  console.error(`Invalid brand/locale combination {brand: '${brand}'', locale: '${locale}''}.`);
}

/**
 * Object containing prodHosts. Used in environmentMapper(), SbxPCC_Wrapper.vue. SbxSc_Wrapper.vue
 * @constant prodHosts
 */
const prodHosts = [
  'www.smartbox.com',
  'www.dakotabox.es',
  'www.dakotabox.fr',
  'www.emozione3.it',
  'www.lavidaesbella.es',
  'www.bongo.nl',
  'www.bongo.be',
  'www.cadeaubox.be',
  'checkout.smartbox.com',
  'checkout.dakotabox.es',
  'checkout.dakotabox.fr',
  'checkout.emozione3.it',
  'checkout.lavidaesbella.es',
  'checkout.bongo.nl',
  'checkout.bongo.be',
  'checkout.cadeaubox.be',
];

/**
 * Object containing preProdHosts. Used in environmentMapper()
 * @constant preProdHosts
 */
const preProdHosts = [
  'front-pp-u3.smartbox.com',
  'preprod.dakotabox.es',
  'preprod.dakotabox.fr',
  'preprod.emozione3.it',
  'preprod.lavidaesbella.es',
  'preprod.bongo.nl',
  'preprod.bongo.be',
  'preprod.cadeaubox.be',
  'web.gitlab.production.smartbox.com',
  'pp-checkout.smartbox.com',
  'pp-checkout.bongo.be',
  'pp-checkout.bongo.nl',
  'pp-checkout.cadeaubox.be',
  'pp-checkout.dakotabox.fr',
  'pp-checkout.dakotabox.es',
  'pp-checkout.emozione3.it',
  'pp-checkout.lavidaesbella.es',
];

const reviewPreprodHost = 'precart-review-pp';

function reviewPreprodHostToM2Admin(absoluteUrl) {
  const url = new URL(absoluteUrl);
  for (const [key, value] of Object.entries(mapM2PPApiUrl)) {
    if (url.pathname.match(key)) {
      return value;
    }
  }
}

function reviewPreprodHostToM2Base(absoluteUrl) {
  const url = new URL(absoluteUrl);
  for (const [key, value] of Object.entries(mapM2PPBaseUrl)) {
    if (url.pathname.match(key)) {
      return value;
    }
  }
}

/**
 * pattern which is maps domain to local host regrex. Used in environmentMapper()
 * @constant localHostPatterns
 * @private
 */
const localHostPatterns = [/localhost:[0-9]{4}/, /dev\.[a-z]/, /local\.search-components\.smartbox\.com/];

/**
 * Object which is maps domain to branding key
 * @constant additionDomainsToLangMap
 * @private
 */
const additionDomainsToLangMap = {
  'com/fr/': 'fr',
  'com/es/': 'es',
  'com/it/': 'it',
  'com/de/': 'de',
  'com/dk/': 'da',
  'com/se/': 'sv',
  'com/ch/': 'de',
  'com/ch/fr/': 'fr',
  'com/ch/it/': 'it',
  'com/ch/de/': 'de',
  'es/': 'es',
  'fr/': 'fr',
  'it/': 'it',
  'be/': 'nl',
  'nl/': 'nl',
  'net/de/': 'de',
  'be/fr/': 'fr',
  'be/nl/': 'nl',
};

/**
 * Object which is maps domain to branding key. Used in brandingImporter()
 * @constant domainBrandingMap
 * @private
 */
const domainBrandingMap = {
  'smartbox.com/': 'sbx',
  'dakotabox.es/': 'dakEs',
  'dakotabox.fr/': 'dakFr',
  'emozione3.it/': 'emo',
  'lavidaesbella.es/': 'lav',
  'bongo.nl/': 'bon',
  'bongo.be/': 'bon',
  'cadeaubox.be/': 'cbx',
};

/**
 * Array of languages. Used in brandingImporter()
 * @constant languageList
 * @private
 */
const languageList = ['en', 'fr', 'es', 'it', 'de', 'nl', 'sv', 'da'];

/**
 * Array of urlPatterns. Used in brandingImporter()
 * @constant urlPatterns
 * @private
 */
const urlPatterns = [
  /https?:\/\/[^/]+\/(ch\/it|ch\/fr|ch\/de)$/i,
  /https?:\/\/[^/]+\/(ch\/it|ch\/fr|ch\/de)\//i,
  /https?:\/\/[^/]+\/(ch\/it|ch\/fr|ch\/de)\?/i,
  /https?:\/\/[^/]+\/(cb\/fr|cb\/nl)$/i,
  /https?:\/\/[^/]+\/(cb\/fr|cb\/nl)\//i,
  /https?:\/\/[^/]+\/(cb\/fr|cb\/nl)\?/i,
  /https?:\/\/[^/]+\/(bb\/fr|bb\/nl)$/i,
  /https?:\/\/[^/]+\/(bb\/fr|bb\/nl)\//i,
  /https?:\/\/[^/]+\/(bb\/fr|bb\/nl)\?/i,
  /https?:\/\/[^/]+\/[a-z]{2}$/i,
  /https?:\/\/[^/]+\/[a-z]{2}\//i,
  /https?:\/\/[^/]+\/[a-z]{2}\?/i,
  /https?:\/\/[^/]+/i,
];

const createUrlPrefix = (urlPrefix, extUrl, isEmptyPathName = false) => {
  const extBaseUrl = new URL(extUrl);
  const hostname = extBaseUrl.hostname.split('.');
  hostname[0] = urlPrefix;
  extBaseUrl.hostname = hostname.join('.');
  if (isEmptyPathName) {
    extBaseUrl.pathname = '';
  }
  return extBaseUrl.href;
};

const mapM2DevBaseUrl = {
  '/bb': 'bongo-be.devint.sbxtest.net',
  '/bn': 'bongo-nl.devint.sbxtest.net',
  '/cb': 'cadeaubox-be.devint.sbxtest.net',
  '/df': 'dakotabox-fr.devint.sbxtest.net',
  '/ds': 'dakotabox-es.devint.sbxtest.net',
  '/ez': 'emozione3-it.devint.sbxtest.net',
  '/lv': 'lavidaesbella-es.devint.sbxtest.net',
};
const mapM2DevApiUrl = {
  '/bb': 'bongo-be-admin.devint.sbxtest.net',
  '/bn': 'bongo-nl-admin.devint.sbxtest.net',
  '/cb': 'cadeaubox-be-admin.devint.sbxtest.net',
  '/df': 'dakotabox-fr-admin.devint.sbxtest.net',
  '/ds': 'dakotabox-es-admin.devint.sbxtest.net',
  '/ez': 'emozione3-it-admin.devint.sbxtest.net',
  '/lv': 'lavidaesbella-es-admin.devint.sbxtest.net',
};

const mapM2PPApiUrl = {
  // don't change the order of this list as they're matched in order
  // for the multilingual fallback to work
  '/bb/fr/': 'https://pp-admin.bongo.be/fr/',
  '/bb/nl/': 'https://pp-admin.bongo.be/nl/',
  '/ch/de/': 'https://pp-admin.smartbox.com/ch/de/',
  '/ch/it/': 'https://pp-admin.smartbox.com/ch/it/',
  '/ch/fr/': 'https://pp-admin.smartbox.com/ch/fr/',
  '/cb/fr/': 'https://pp-admin.cadeaubox.be/',
  '/cb/nl/': 'https://pp-admin.cadeaubox.be/nl/',
  '/bb/': 'https://pp-admin.bongo.be/nl/',
  '/bn/': 'https://pp-admin.bongo.nl/',
  '/cb/': 'https://pp-admin.cadeaubox.be/',
  '/ch/': 'https://pp-admin.smartbox.com/ch/de/',
  '/fr/': 'https://pp-admin.smartbox.com/fr/',
  '/es/': 'https://pp-admin.smartbox.com/es/',
  '/it/': 'https://pp-admin.smartbox.com/it/',
  '/se/': 'https://pp-admin.smartbox.com/se/',
  '/dk/': 'https://pp-admin.smartbox.com/dk/',
  '/ie/': 'https://pp-admin.smartbox.com/ie/',
  '/df/': 'https://pp-admin.dakotabox.fr/',
  '/ds/': 'https://pp-admin.dakotabox.es/',
  '/ez/': 'https://pp-admin.emozione3.it/',
  '/lv/': 'https://pp-admin.lavidaesbella.es/',
};

const mapM2PPBaseUrl = {
  // don't change the order of this list as they're matched in order
  // for the multilingual fallback to work
  '/bb/fr/': 'https://pp-checkout.bongo.be/fr/',
  '/bb/nl/': 'https://pp-checkout.bongo.be/nl/',
  '/ch/de/': 'https://pp-checkout.smartbox.com/ch/de/',
  '/ch/it/': 'https://pp-checkout.smartbox.com/ch/it/',
  '/ch/fr/': 'https://pp-checkout.smartbox.com/ch/fr/',
  '/cb/fr/': 'https://pp-checkout.cadeaubox.be/fr/',
  '/cb/nl/': 'https://pp-checkout.cadeaubox.be/nl/',
  '/bb/': 'https://pp-checkout.bongo.be/',
  '/bn/': 'https://pp-checkout.bongo.nl/',
  '/cb/': 'https://pp-checkout.cadeaubox.be/',
  '/ch/': 'https://pp-checkout.smartbox.com/ch/de/',
  '/fr/': 'https://pp-checkout.smartbox.com/fr/',
  '/es/': 'https://pp-checkout.smartbox.com/es/',
  '/it/': 'https://pp-checkout.smartbox.com/it/',
  '/se/': 'https://pp-checkout.smartbox.com/se/',
  '/dk/': 'https://pp-checkout.smartbox.com/dk/',
  '/ie/': 'https://pp-checkout.smartbox.com/ie/',
  '/df/': 'https://pp-checkout.dakotabox.fr/',
  '/ds/': 'https://pp-checkout.dakotabox.es/',
  '/ez/': 'https://pp-checkout.emozione3.it/',
  '/lv/': 'https://pp-checkout.lavidaesbella.es/',
};

/**
 * This returns the baseUrl for of the site the component is running on. It is matched against regrex urlPatterns
 or fallsback to a relative path. Eg. this can be used in javascript events or Ajax calls.
 * @function baseUrl
 * @url string | null
 * @example
 * https://www.smartbox.com/ch/it/nostri-smartbox/soggiorni/fuga-romantica-in-svizzera-2-notti-in-b-b-per-2-persone-1339018.html
 * // returns https://www.smartbox.com/ch/it/
 * https://www.bongo.be/nl/cadeaubonnen/overnachten/lang-weekend-met-ontbijt-en-fietsenverhuur-in-amsterdam-1390997.html
 * // return https://www.bongo.be/nl/
 * @returns  {String} Returns the baseUrl of the component
 */
function baseUrl(urlProp = null) {
  let url = '';
  /* eslint-disable no-useless-escape */

  if (!process.server) {
    // eslint-disable-next-line no-undef
    if (globalThis && globalThis.baseUrl) {
      // eslint-disable-next-line no-undef
      url = globalThis.baseUrl;
    }
  }
  if (urlProp) {
    url = urlProp;
  } else {
    // for use in PCS server-side api context
    if (typeof(window) !== 'object') {
      return '/'
    }
    const devMode =
      process.env.NODE_ENV === 'development' ||
      window.location.hostname == 'localhost' ||
      window.location.hostname == 'pcc.defuse.sbxtest.net' ||
      window.location.hostname == 'sc.defuse.sbxtest.net' ||
      window.location.pathname == '/precart-components/iframe.html';

    url = devMode && sessionStorage.getItem('baseUrlOveride') !== null ? sessionStorage.getItem('baseUrlOveride') : window.location.href;
  }

  for (let i = 0; i < urlPatterns.length; i++) {
    const match = url.toLowerCase().match(urlPatterns[i]);
    if (match) return match[0].replace(/(\?|\/|\/qr\/)$/, '') + '/';
  }
  return '/'; // fallback to relative path
  // return ''
}

const m2BaseUrl = (url = null, env = null) => {
  const absoluteUrl = baseUrl(url);

  if(absoluteUrl.includes(reviewPreprodHost)) {
    return reviewPreprodHostToM2Base(absoluteUrl);
  }
  const envOverride = env || environmentMapper();
  //Check External Domain
  if ([environments.production, environments.preproduction].includes(envOverride)) {
    const externalDomains = [...preProdHosts, ...prodHosts];

    if (externalDomains.filter(x => absoluteUrl.includes(x)).length) {
      const m2Prefix = environments.preproduction == envOverride ? 'pp-checkout' : 'checkout';
      return createUrlPrefix(m2Prefix, absoluteUrl);
    }
  }

  const devBaseUrl = () => {
    //Calcuate fallback url
    const m2DevBaseUrl = new URL(absoluteUrl);
    m2DevBaseUrl.hostname = 'smartbox-com.devint.sbxtest.net';
    for (const brandId of Object.keys(mapM2DevBaseUrl)) {
      if (m2DevBaseUrl.pathname.match(brandId)) {
        m2DevBaseUrl.hostname = mapM2DevBaseUrl[brandId];
        m2DevBaseUrl.pathname = m2DevBaseUrl.pathname.replace(brandId, '');
        m2DevBaseUrl.port = '';
      }
    }
    return m2DevBaseUrl.href;
  };

  // All other envs return devBaseUrl
  return devBaseUrl();
};

const m2ApiUrl = (url = null, env = null) => {
  const absoluteUrl = baseUrl(url);

  if(absoluteUrl.includes(reviewPreprodHost)) {
    return reviewPreprodHostToM2Admin(absoluteUrl);
  }

  const envOverride = env || environmentMapper();
  //Check External Domain
  if ([environments.production, environments.preproduction].includes(envOverride)) {
    const externalDomains = [...preProdHosts, ...prodHosts];

    if (externalDomains.filter(x => absoluteUrl.includes(x)).length) {
      const m2Prefix = environments.preproduction == envOverride ? 'pp-admin' : 'admin';
      return createUrlPrefix(m2Prefix, absoluteUrl);
    }
  }

  const devApiUrl = () => {
    //Calcuate fallback url
    const m2DevApiUrl = new URL(absoluteUrl);
    m2DevApiUrl.hostname = 'smartbox-com-admin.devint.sbxtest.net';
    for (const brandId of Object.keys(mapM2DevApiUrl)) {
      if (m2DevApiUrl.pathname.match(brandId)) {
        m2DevApiUrl.hostname = mapM2DevApiUrl[brandId];
        m2DevApiUrl.pathname = m2DevApiUrl.pathname.replace(brandId, '');
        m2DevApiUrl.port = '';
      }
    }
    return m2DevApiUrl.href;
  };

  // All other envs return devApiUrl
  return devApiUrl();
};

const myaccountBaseUrl = (url = null, env = null) => {
  const absoluteUrl = baseUrl(url);
  const envOverride = env || environmentMapper();
  //Check External Domain
  if ([environments.production, environments.preproduction].includes(envOverride)) {
    const externalDomains = [...preProdHosts, ...prodHosts];

    if (externalDomains.filter(x => absoluteUrl.includes(x)).length) {
      const myaccountPrefix = environments.preproduction == envOverride ? 'myaccount-pp' : 'myaccount';
      return createUrlPrefix(myaccountPrefix, absoluteUrl);
    }
  }

  const devMyAccountBaseUrl = () => {
    //Calcuate fallback url
    const devMyAccountUrl = new URL(absoluteUrl);
    devMyAccountUrl.hostname = 'shire-ui.devint.sbxtest.net';
    devMyAccountUrl.port = '';
    return devMyAccountUrl.href;
  };
  // All other envs return devMyAccountBaseUrl
  return devMyAccountBaseUrl();
};

const myaccountApiUrl = (url = null, env = null) => {
  const absoluteUrl = baseUrl(url);
  const envOverride = env || environmentMapper();
  //Check External Domain
  if ([environments.production, environments.preproduction].includes(envOverride)) {
    const externalDomains = [...preProdHosts, ...prodHosts];

    if (externalDomains.filter(x => absoluteUrl.includes(x)).length) {
      const myaccountApiPrefix = environments.preproduction == envOverride ? 'myaccount-api-pp' : 'myaccount-api';
      return createUrlPrefix(myaccountApiPrefix, absoluteUrl, true);
    }
  }

  const devMyAccountApiUrl = () => {
    //Calcuate fallback url
    const devMyAccountUrl = new URL(absoluteUrl);
    devMyAccountUrl.hostname = 'shire-api-public.devint.sbxtest.net';
    devMyAccountUrl.pathname = '';
    devMyAccountUrl.port = '';
    return devMyAccountUrl.href;
  };
  // All other envs return devMyAccountBaseUrl
  return devMyAccountApiUrl();
};

/**
 * @description Object of environments. Used in  supportsLocale()
 * @private
 */
const environments = {
  production: 'prod',
  preproduction: 'preprod',
  devint: 'devint',
  local: 'local',
};

/**
 * @description Function to determine environment based on baseURL. Used in getSearchURL /  brandingImporter()
 * @private
 returns @string
 */
function environmentMapper(url = null) {
  const baseURL = () => {
    const base = baseUrl(url);
    if (base !== '/') {
      const url = new URL(base);
      return url.hostname;
    } else {
      // for use in PCS server-side api context
      if (typeof(window) !== 'object') {
        return '/'
      }
      return window.location.hostname;
    }
  };

  if (prodHosts.includes(baseURL())) {
    return environments.production;
  }

  if (preProdHosts.includes(baseURL())) {
    return environments.preproduction;
  }

  // local will now point to devint, disabling so no need for a check against localhost patterns
  // keeping the functionlity here but commented out incase it needs to be re-instated

  const hasLocalMatches = localHostPatterns.find(pattern => {
    return pattern.test(baseURL());
  });

  if (hasLocalMatches) {
    return environments.local;
  } else {
    return environments.devint;
  }
}

const searchURL = process.env.VUE_APP_SEARCH_URL;
const preprodURL = process.env.VUE_APP_PREPROD_URL;
const devintURL = process.env.VUE_APP_DEVINT_URL;

const urlEnvMap = {
  [environments.production]: searchURL,
  [environments.preproduction]: preprodURL,
  [environments.devint]: devintURL,
  [environments.local]: devintURL,
};

const getSearchURL = (url = null) => urlEnvMap[environmentMapper(url)] || searchURL;

const api = {
  async get(url) {
    const { searchURLHeaders } = brandingImporter();
    const options = {
      method: 'GET',
      headers: searchURLHeaders,
    };
    let data, error;
    fetch(url, options)
      .then(response => response.json())
      .then(fetchData => (data = fetchData))
      .catch(err => (error = err));

    return [error, data];
  },
};

/**
 * @function brandingImporter
 * @description This function returns the brandingObject as determined from the URL
 * @return {Object}  brandingObject
 * @property {Object} styles - The brand styles as designated in localization brandingThemes[brand]
 * @property {string} brand  - The brand as a string returned from getBrand()
 * @property {string} locale - The locale as a string returned from getLocale() i.e. fr-FR, etc
 * @property {Boolean} isPrimaryBrand - The boolean returned from isPrimaryBrand()
 * @property {Object} contextHeaders - The object returns the required headers object for using the Search API `{ brand, language, country }`
 * @property {string} contextKey - Context key use in branding items object for storing data
 * @property {Object} currency - The object returned getLocaleCurrencyFormat() `{ "brand", "locale", "currency", "currencyStyle", "delimiter" , "thousands" }`
 * @property {string} cookieKey - Cookie key used in recently viewed products
 * @property {Object} searchURLHeaders - The object returns the required headers object for using the Search API `{ brand, language, country }`
 * @property {string} searchURL - URL used for calling search API
 * @example
 * {
 "styles": {
 "--brand-theme": "sbx",
 "--brand-primary-color-1": "#EB5F40",
 "--brand-highlight-card-background": "#FFF8EA",
 "--brand-section-background": "#F9F6F6",
 "--brand-icon-grey-shade-1": "#777777",
 "--brand-secondary-icon-green": "unset",
 "--brand-search-bar-background": "#fff",
 "--brand-newsletter-footer-background": "#4C509D",
 "--brand-footer-background": "#EEECE8",
 "--brand-footer-title": "#6e6963",
 "--brand-footer-content": "#343533",
 "--brand-footer-icon": "#f4f0ed",
 "--brand-dark-blue": "#4C509D",
 "--brand-light-blue": "#B1DDE8",
 "--brand-dark-green": "#006648",
 "--brand-bright-green": "#009847",
 "--brand-light-green": "#D1D700",
 "--brand-yellow-shade-1": "#FFD300",
 "--brand-pink": "#F7C4DC",
 "--brand-yellow-shade-2": "#FFE598",
 "--brand-purple": "#7E2182",
 "--brand-font-regular": "smartbox",
 "--brand-font-bold": "smartbox-bold",
 "--brand-font-medium": "smartbox-medium"
 },
 "brand": "sbx",
 "locale": "fr-FR",
 "isPrimaryBrand": true,
 "contextHeaders": {
 "brand": "sbx",
 "language": "fr",
 "country": "fr"
 },
 "contextKey": "SBX-FR-fr-",
 "currency": {
 "brand": "sbx",
 "locale": "fr-FR",
 "currency": "€",
 "currencyStyle": "postS",
 "delimiter": ",",
 "thousands": " "
 },
 "cookieKey": "SBX_FR",
 "searchURLHeaders": {
 "brand": "sbx",
 "language": "fr",
 "country": "fr"
 },
 "searchURL": "search.smartbox.com",
 }
 */
const brandingImporter = ({ brandOverride = null, localeOverride = null, url = null } = {}) => {
  const locale = getLocale(localeOverride, url);
  const brand = getBrand(brandOverride, url);
  return {
    styles: brandingThemes[brand],
    brand,
    locale,
    isPrimaryBrand: isPrimaryBrand(brand),
    contextHeaders: {
      brand: brand.toLowerCase().substring(0, 3),
      language: fromLocaleToLangCode(locale).toLowerCase(),
      country: fromLocaleToCountryCode(locale).toLowerCase(),
    },
    contextKey:
      brand.toUpperCase().substring(0, 3) + '-' + fromLocaleToCountryCode(locale) + '-' + fromLocaleToLangCode(locale).toLowerCase() + '-',
    currency: getLocaleCurrencyFormat(brand, locale),
    cookieKey: brand.toUpperCase().substring(0, 3) + '_' + fromLocaleToCountryCode(locale),
    searchURLHeaders: {
      brand: brand.toLowerCase().substring(0, 3),
      language: fromLocaleToLangCode(locale).toLowerCase(),
      country: fromLocaleToCountryCode(locale).toLowerCase(),
    },
    searchURL: getSearchURL(url),
  };
};

const defaultLocale = locales.french;
const defaultBrand = brands.smartbox;

/**
 * @description Checks if brand is primary (bongo or smartbox). Used in brandingImporter()
 * @private
 */
function isPrimaryBrand(brand) {
  return brand === brands.smartbox || brand === brands.bongo;
}

/**
 * @description Gets brand from url / sessionOverride. Use in brandingImporter()
 * @private
 */
function getBrand(override = null, url = null) {
  // Make sure we always return a valid brand
  if (override) {
    if (Object.values(brands).includes(override)) {
      return override;
    }
    return defaultBrand;
  }

  const baseURL = baseUrl(url);

  for (const [brand, urlExpressions] of Object.entries(domainSearchBrandingMap)) {
    if (urlExpressions.find(expr => expr.test(baseURL))) {
      return brand;
    }
  }
  return defaultBrand;
}

/**
 * @description Gets locale from url / sessionOverride. Use in brandingImporter()
 * @private
 */
function getLocale(override = null, url = null) {
  // Make sure we always return a valid locale
  if (override) {
    if (Object.values(locales).includes(override)) {
      return override;
    }
    return defaultLocale;
  }

  const baseURL = baseUrl(url);
  for (const [locale, urlExpressions] of Object.entries(localeMap)) {
    if (urlExpressions.find(expr => expr.test(baseURL))) {
      return locale;
    }
  }
  return defaultLocale;
}

/**
 * @description Converts locale to country code. Use in brandingImporter()
 * @private
 */
function fromLocaleToCountryCode(locale) {
  if (!locale) return locale;
  return locale.split('-')[1];
}

/**
 * @description Converts country code to locale. Use in brandingImporter()
 * @private
 */
function fromLocaleToLangCode(locale) {
  if (!locale) return locale;
  return locale.split('-')[0];
}

function dynamicBrandTranslation(trans) {
  const { brand, contextHeaders } = brandingImporter();
  const brandTrans = `${trans}.${brand}`;
  // $te is a method which checks the exist of the key, in this case if a branded key exists
  const brandCheck = this.$te(brandTrans, contextHeaders.language);
  return brandCheck ? brandTrans : trans;
}

const fontFaces = `
  @font-face {
    font-family: 'din';
    src: url('//media.smartbox.com/media/fonts/DINWeb.eot?#iefix') format('embedded-opentype'),
         url('//media.smartbox.com/media/fonts/DINWeb.woff') format('woff');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'din-bold';
    src: url('//media.smartbox.com/media/fonts/DINWeb-Bold.eot?#iefix') format('embedded-opentype'),
         url('//media.smartbox.com/media/fonts/DINWeb-Bold.woff') format('woff');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'din-medium';
    src: url('//media.smartbox.com/media/fonts/DINWeb-Medium.eot?#iefix') format('embedded-opentype'),
         url('//media.smartbox.com/media/fonts/DINWeb-Medium.woff') format('woff');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'smartbox-icons-extended';
    src: url('//media.smartbox.com/media/fonts/smartbox-icons-extended-webfont.eot');
    src: url('//media.smartbox.com/media/fonts/smartbox-icons-extended-webfont.eot?#iefix') format('embedded-opentype'),
    url('//media.smartbox.com/media/fonts/smartbox-icons-extended-webfont.woff2') format('woff2'),
    url('//media.smartbox.com/media/fonts/smartbox-icons-extended-webfont.woff') format('woff'),
    url('//media.smartbox.com/media/fonts/smartbox-icons-extended-webfont.ttf') format('truetype'),
    url('//media.smartbox.com/media/fonts/smartbox-icons-extended-webfont.svg#smartbox-iconsregular') format('svg');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'smartbox';
    src: url('//media.smartbox.com/media/fonts/ABCProphet-Regular.woff2') format('woff2');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
}

  @font-face {
    font-family: 'smartbox-bold';
    src: url('//media.smartbox.com/media/fonts/ABCProphet-Bold.woff2') format('woff2');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'smartbox-medium';
    src: url('//media.smartbox.com/media/fonts/ABCProphet-Medium.woff2') format('woff2');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'bon';
    src: url('//media.smartbox.com/media/fonts/Monts-Regular.woff2') format('woff2');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'bon-bold';
    src: url('//media.smartbox.com/media/fonts/Monts-Bold.woff2') format('woff2');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'bon-medium';
    src: url('//media.smartbox.com/media/fonts/Monts-Med.woff2') format('woff2');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
  }
`;

/**
 * This checks if fontFaces have been loaded into the DOM and loads if neccesary. It directly modifies the DOM object
 * @function addFontsStyleTag
 productList.js */
function addFontsStyleTag() {
  if (window.sbxComponents) {
    window.sbxComponents++;
    return;
  }

  window.sbxComponents = 1;
  // add the style tag
  const style = document.createElement('style');
  style.dataset.description = 'sbx-font-faces';

  style.innerHTML = fontFaces;
  document.head.appendChild(style);
}

/**
 * This checks if fontFaces have been loaded into the DOM and removes if neccesary. It directly modifies the DOM object
 * @function removeFontsStyleTag
 */
function removeFontsStyleTag() {
  window.sbxComponents--;

  if (!window.sbxComponents) {
    // remove the style tag
    const style = document.querySelector('style[data-description="sbx-font-faces"]');

    document.head.removeChild(style);
  }
}

const numberProductsToShow = 8; // 4 last recently viewed boxes
const ttl = 1209600000; // two weeks long

/**
 * Gets the browser cookie from the DOM and returns it as a string
 * @function getCookie
 * @param {string} - Name
 * @return {string} value
 */
function getCookie(name) {
  return document.cookie.split(';').find(item => item.trim().startsWith(name));
}

function getCookieValue(name) {
  const cookieValue = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
  return cookieValue ? cookieValue.pop() : '';
}

/**
 * Sets the browser cookie in the DOM. This modifies the DOM directly.
 * @function setCookie
 * @param {string} - name
 * @param {string} - value
 * @param {string} - expiry date
 */
function setCookie(name, value, expires = null) {
  window.document.cookie = `${name}=${value}; Path=/; ${expires ? expires : ''}`;
}

/**
 * Removes the browser cookie in the DOM. This modifies the DOM directly.
 * @function removeCookie
 * @param {string} - name
 */
function removeCookie(name) {
  document.cookie = `${name}=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
}

function nowTimestamp() {
  return new Date().getTime();
}

function storeKey() {
  const url = baseUrl();
  const { contextKey } = brandingImporter({ url });
  return `recentlyViewed_${contextKey}`;
}

function getRecentlyViewedFromCookie() {
  const viewedItemsData = getCookie(storeKey());
  let viewedItems =
    viewedItemsData !== undefined && viewedItemsData !== '' ? JSON.parse(viewedItemsData.replace(`${storeKey()}=`, '')) : [];

  //Remove expired items
  if (viewedItems.length) {
    viewedItems = viewedItems.filter(item => nowTimestamp() - item.timestamp <= ttl);
  }
  return viewedItems;
}

function setRecentlyViewedToCookie(pimId) {
  const viewedItems = getRecentlyViewedFromCookie();
  const removeIndex = viewedItems.findIndex(item => item.id === pimId);

  if (removeIndex !== -1) {
    viewedItems.splice(removeIndex, 1);
  } else if (viewedItems.length >= numberProductsToShow) {
    viewedItems.pop();
  }

  //Add current box
  viewedItems.unshift({
    id: pimId,
    timestamp: nowTimestamp(),
  });

  setCookie(storeKey(), JSON.stringify(viewedItems), ttl);
}

function getTokenFromCookie() {
  const url = baseUrl();
  const { cookieKey } = brandingImporter({ url });
  const token = getCookieValue(cookieKey);
  return token ? `Bearer ${token}` : '';
}

/**
 * @description Array of supported locales. Used in  supportsLocale()
 * @private
 */
const supportedLocales = [
  {
    brand: brands.smartbox,
    locale: locales.french,
  },
  {
    brand: brands.smartbox,
    locale: locales.italian,
  },
  {
    brand: brands.smartbox,
    locale: locales.spanish,
  },
  {
    brand: brands.smartbox,
    locale: locales.swissFrench,
  },
  {
    brand: brands.smartbox,
    locale: locales.swissGerman,
  },
  {
    brand: brands.smartbox,
    locale: locales.swissItalian,
  },
  {
    brand: brands.smartbox,
    locale: locales.swedish,
  },
  {
    brand: brands.smartbox,
    locale: locales.danish,
  },
  {
    brand: brands.smartbox,
    locale: locales.german,
  },
  {
    brand: brands.lavidaesbella,
    locale: locales.spanish,
  },
  {
    brand: brands.dakotaFrance,
    locale: locales.french,
  },
  {
    brand: brands.dakotaSpain,
    locale: locales.spanish,
  },
  {
    brand: brands.bongo,
    locale: locales.dutch,
  },
  {
    brand: brands.bongo,
    locale: locales.belgianDutch,
  },
  {
    brand: brands.bongo,
    locale: locales.belgianFrench,
  },
  {
    brand: brands.cadeaubox,
    locale: locales.belgianFrench,
  },
  {
    brand: brands.cadeaubox,
    locale: locales.belgianDutch,
  },
  {
    brand: brands.emozione,
    locale: locales.italian,
  },
];

/**
 Function to check supported locales. Used in  supportsLocale()
 * @private
 * @param brand string
 * @param locale string
 */
function supportsLocale(brand, locale) {
  return !!supportedLocales.find(item => item.brand === brand && item.locale === locale);
}

/**
 * @param {[type]} securityKey
 * @param {[type]} thumborServerUrl
 */

async function createHmac(key, message) {
  const encoder = new TextEncoder();
  const cryptoKey = await window.crypto.subtle.importKey('raw', encoder.encode(key), { name: 'HMAC', hash: 'SHA-256' }, false, ['sign']);
  const signature = await window.crypto.subtle.sign('HMAC', cryptoKey, encoder.encode(message));
  return new Uint8Array(signature);
}

function Thumbor(securityKey, thumborServerUrl) {
  this.THUMBOR_SECURITY_KEY = securityKey;
  this.THUMBOR_URL_SERVER = thumborServerUrl;
  this.imagePath = '';
  this.width = 0;
  this.height = 0;
  this.smart = false;
  this.fitInFlag = false;
  this.withFlipHorizontally = false;
  this.withFlipVertically = false;
  this.halignValue = null;
  this.valignValue = null;
  this.cropValues = null;
  this.meta = false;
  this.filtersCalls = '';
}

Thumbor.prototype = {
  TOP: 'top',
  MIDDLE: 'middle',
  BOTTOM: 'bottom',
  RIGHT: 'right',
  CENTER: 'center',
  LEFT: 'left',

  /**
   * Set path of image
   * @param {String} imagePath [description]
   */
  setImagePath: function (imagePath) {
    this.imagePath = imagePath.charAt(0) === '/' ? imagePath.substring(1, imagePath.length) : imagePath;
    return this;
  },

  /**
   * Converts operation array to string
   * @return {String}
   */
  getOperationPath: function () {
    const parts = this.urlParts();
    if (0 === parts.length) {
      return '';
    }
    return parts.join('/') + '/';
  },

  /**
   * Build operation array
   * @return {Array}
   */
  urlParts: function () {
    if (!this.imagePath) {
      throw new Error("The image url can't be null or empty.");
    }
    const parts = [];
    if (this.meta) {
      parts.push('meta');
    }
    if (this.cropValues) {
      parts.push(this.cropValues.left + 'x' + this.cropValues.top + ':' + this.cropValues.right + 'x' + this.cropValues.bottom);
    }
    if (this.fitInFlag) {
      parts.push('fit-in');
    }
    if (this.width || this.height || this.withFlipHorizontally || this.withFlipVertically) {
      let sizeString = '';
      if (this.withFlipHorizontally) {
        sizeString += '-';
      }
      sizeString += this.width;
      sizeString += 'x';
      if (this.withFlipVertically) {
        sizeString += '-';
      }
      sizeString += this.height;
      parts.push(sizeString);
    }
    if (this.halignValue) {
      parts.push(this.halignValue);
    }
    if (this.valignValue) {
      parts.push(this.valignValue);
    }
    if (this.smart) {
      parts.push('smart');
    }
    if (this.filtersCalls.length) {
      parts.push('filters:' + this.filtersCalls);
    }
    return parts;
  },

  /**
   * Resize the image to the specified dimensions. Overrides any previous call
   * to `fitIn` or `resize`.
   *
   * Use a value of 0 for proportional resizing. E.g. for a 640 x 480 image,
   * `.resize(320, 0)` yields a 320 x 240 thumbnail.
   *
   * Use a value of 'orig' to use an original image dimension. E.g. for a 640
   * x 480 image, `.resize(320, 'orig')` yields a 320 x 480 thumbnail.
   * @param  {String} width
   * @param  {String} height
   */
  resize: function (width, height) {
    this.width = width;
    this.height = height;
    this.fitInFlag = false;
    return this;
  },

  smartCrop: function (smartCrop) {
    this.smart = smartCrop;
    return this;
  },

  /**
   * Resize the image to fit in a box of the specified dimensions. Overrides
   * any previous call to `fitIn` or `resize`.
   *
   * @param  {String} width
   * @param  {String} height
   */
  fitIn: function (width, height) {
    this.width = width;
    this.height = height;
    this.fitInFlag = true;
    return this;
  },

  /**
   * Flip image horizontally
   */
  flipHorizontally: function () {
    this.withFlipHorizontally = true;
    return this;
  },

  /**
   * Flip image vertically
   */
  flipVertically: function () {
    this.withFlipVertically = true;
    return this;
  },

  /**
   * Specify horizontal alignment used if width is altered due to cropping
   * @param  {String} halign 'left', 'center', 'right'
   */
  halign: function (halign) {
    if (halign === this.LEFT || halign === this.RIGHT || halign === this.CENTER) {
      this.halignValue = halign;
    } else {
      throw new Error('Horizontal align must be left, right or center.');
    }
    return this;
  },

  /**
   * Specify vertical alignment used if height is altered due to cropping
   * @param  {String} valign 'top', 'middle', 'bottom'
   */
  valign: function (valign) {
    if (valign === this.TOP || valign === this.BOTTOM || valign === this.MIDDLE) {
      this.valignValue = valign;
    } else {
      throw new Error('Vertical align must be top, bottom or middle.');
    }
    return this;
  },

  /**
   * Specify that JSON metadata should be returned instead of the thumbnailed
   * image.
   * @param  {Boolean} metaDataOnly [description]
   */
  metaDataOnly: function (metaDataOnly) {
    this.meta = metaDataOnly;
    return this;
  },

  /**
   * Append a filter, e.g. quality(80)
   * @param  {String} filterCall
   */
  filter: function (filterCall) {
    this.filtersCalls = filterCall;
    return this;
  },

  /**
   * Manually specify crop window.
   * @param  {Integer} left
   * @param  {Integer} top
   * @param  {Integer} right
   * @param  {Integer} bottom
   * @return {[type]}
   */
  crop: function (left, top, right, bottom) {
    this.cropValues = {
      left: left,
      top: top,
      right: right,
      bottom: bottom,
    };
    return this;
  },

  /**
   * Combine image url and operations with secure and unsecure (unsafe) paths
   * @return {String}
   */
  buildUrl: function () {
    const operation = this.getOperationPath();
    if (this.THUMBOR_SECURITY_KEY) {
      var key = createHmac('sha1', this.THUMBOR_SECURITY_KEY)
        .update(operation + this.imagePath)
        .digest('base64');

      key = key.replace(/\+/g, '-').replace(/\//g, '_');
      return this.THUMBOR_URL_SERVER + '/' + key + '/' + operation + this.imagePath;
    } else {
      return this.THUMBOR_URL_SERVER + '/unsafe/' + operation + this.imagePath;
    }
  },
};

/* eslint-disable no-param-reassign */

function initLazyLoading(image) {
  const lazyloadImage = image ? image : document.querySelector('.lazy');
  if (!lazyloadImage) {
    return;
  }

  if ('IntersectionObserver' in window) {
    //config to trigger the observer’s callback immediately after having an intersection
    const options = {
      root: null,
      rootMargin: '50px 0px',
      threshold: 0,
    };

    const imageObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const image = entry.target;
          image.src = image.dataset.src;
          image.classList.remove('lazy');
          imageObserver.unobserve(image);
        }
      });
    }, options);

    imageObserver.observe(lazyloadImage);
  } else {
    let lazyloadThrottleTimeout;

    // eslint-disable-next-line no-inner-declarations
    function lazyload() {
      if (lazyloadThrottleTimeout) {
        clearTimeout(lazyloadThrottleTimeout);
      }

      lazyloadThrottleTimeout = setTimeout(() => {
        const scrollTop = window.pageYOffset;
        if (lazyloadImage.offsetTop < window.innerHeight + scrollTop) {
          lazyloadImage.src = lazyloadImage.dataset.src;
          lazyloadImage.classList.remove('lazy');
        }
        if (!lazyloadImage) {
          document.removeEventListener('scroll', lazyload);
          window.removeEventListener('resize', lazyload);
          window.removeEventListener('orientationChange', lazyload);
        }
      }, 20);
    }

    document.addEventListener('scroll', lazyload);
    window.addEventListener('resize', lazyload);
    window.addEventListener('orientationChange', lazyload);
  }
}

// Debounce
function debounce(callback, time = 100) {
  let timer = null;
  if (timer) clearTimeout(timer);
  timer = setTimeout(callback, time);
}

const lazyPlaceholder = 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==';

const generateNewUrl = (url, width = 640, height = 480) => {
  // Clunky function, want this tidying up in a dedicated component
  const basePath = url.substring(0, url.lastIndexOf('/') + 1);
  const imgPath = url.substring(url.lastIndexOf('/') + 1, url.length);
  const thumbor = new Thumbor('', basePath);
  const thumborize = thumbor
    //.filter('format(webp)') //remove format webp as it doesn't render quite good for png
    .setImagePath(imgPath)
    .resize(width, height)
    .buildUrl();
  const finalUrl = thumborize.replace('/unsafe/', '');
  return finalUrl;
};

const findImageAlt = element => {
  const allImages = element.querySelectorAll('img');
  if (!allImages.length) {
    return true;
  }
  for (const img of allImages) {
    if (!img.hasAttribute('alt')) {
      return false;
    }
    return true;
  }
};

/** @module @sbx/prec-shared-utils */


function to(promise) {
  return promise
    .then(data => {
      return [null, data];
    })
    .catch(err => [err]);
}

export { Thumbor, addFontsStyleTag, additionDomainsToLangMap, api, baseUrl, brandingImporter, debounce, domainBrandingMap, dynamicBrandTranslation, environmentMapper, environments, findImageAlt, formatPrice, fromLocaleToCountryCode, fromLocaleToLangCode, generateNewUrl, getCookie, getCookieValue, getLocaleCurrencyFormat, getRecentlyViewedFromCookie, getSearchURL, getTokenFromCookie, initLazyLoading, languageList, lazyPlaceholder, localHostPatterns, m2ApiUrl, m2BaseUrl, myaccountApiUrl, myaccountBaseUrl, preProdHosts, prodHosts, removeCookie, removeFontsStyleTag, reviewPreprodHost, reviewPreprodHostToM2Admin, reviewPreprodHostToM2Base, setCookie, setRecentlyViewedToCookie, supportsLocale, to };
